import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { ComplexValue, FavouriteReplaceDomainNodes } from 'app/types-shared';
import { ButtonTertiary, ElementLoader } from 'ui';
import {
  getReplaceDomainNodes, getSelectedDefaultOptionIds, mapDummyReplaceDomainNodes
} from 'app/components/filters/filter-replacements/get-replace-domain-nodes';
import { ReplaceDomainNodeType } from 'app/components/filters/filter-replacements/constants';
import { FilterReplacementsRemoveFiltersSelect }
  from 'app/components/filters/filter-replacements/remove-filters-select';
import { FilterReplacementsInfo } from 'app/components/filters/filter-replacements/filter-replacement-info';
import { FiltersTranslation } from 'app/area/filters/constants';
import { createExampleInfoText } from 'app/components/filters/filter-replacements/create-example-info-text';
import { ModalSize } from 'app/components/constants';
import styles from './section-filters.scss';

export interface FilterReplacementsRemoveFiltersProps {
  replaceDomainNodes: FavouriteReplaceDomainNodes[];
  removeDomainNodeOptions: ComplexValue<number>[];
  fetchingExtendedReplaceDomainNodes?: boolean;
  translation: FiltersTranslation;
  locale: string;
  onLoadRemoveNodesFields: ({ optionsIds, query }: { optionsIds?: number[]; query?: string }) => void;
  updateReplaceDomainNodes: (replaceDomainNodes: FavouriteReplaceDomainNodes[]) => void;
}

export const FilterReplacementsRemoveFilters = (props: FilterReplacementsRemoveFiltersProps) => {

  const dummyReplaceDomainNodes = getReplaceDomainNodes(ReplaceDomainNodeType.Dummy, props.replaceDomainNodes);
  const [isExpanded, setIsExpanded] = useState(false);

  const valueItems = dummyReplaceDomainNodes.map(node => ({
    value: node.domainNode.v,
    description: node.domainNode?.domains?.some(domain => !!domain?.ald && !!domain?.pad) 
    ? node.domainNode?.domains.find(domain => !!domain.ald && !!domain?.pad)?.ald 
    : node.domainNode.d
  })) || [];

  const onToggle = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  const onSelectChange = (currentDummyNodes: ComplexValue<number>[]) => {
    const newReplaceDomainNodes = mapDummyReplaceDomainNodes(currentDummyNodes, props.replaceDomainNodes);
    props.updateReplaceDomainNodes(newReplaceDomainNodes);
  };

  return <>
    <div className={`${styles.filterReplacementWrapper} mt-4`}>
      <div className={styles.filterReplacementContent}>
        <h3>
          {`${props.translation.filter_replacements_remove_filters_title} 
          ${dummyReplaceDomainNodes.length > 0 ? `(${dummyReplaceDomainNodes.length})` : ''}`}
        </h3>
        <div className={styles.toggleExpand}>
          <ButtonTertiary onClick={onToggle}>
            {isExpanded ?
              props.translation.filter_replacements_hide_details :
              props.translation.filter_replacements_show_details}
            <FiChevronDown className={isExpanded ? 'expand-icon-down' : 'expand-icon-up'} />
          </ButtonTertiary>
        </div>
      </div>
      <div className={isExpanded ? 'mt-3' : 'd-none'}>
        <p>{props.translation.filter_replacements_remove_filters_description}</p>
        <FilterReplacementsInfo
          size={ModalSize.large}
          translation={props.translation}
          titleText={props.translation.filter_replacements_remove_filters_title}
          infoText={<div className="row">
            <div className="col-12">
              {createExampleInfoText(
                props.translation.filter_replacements_remove_filters_info_text,
                <span className={styles.exampleTitle}>
                  {props.translation.filter_replacements_remove_filters_example}
                </span>,
                <span className={styles.exampleHighlightedText}>
                  {props.translation.filter_replacements_remove_filters_case_date}
                </span>,
                <span className={styles.exampleHighlightedText}>
                  {props.translation.filter_replacements_remove_filters_days_since_last_loss_time_accident}
                </span>
              )}
            </div>
          </div>} />

        <div className={styles.listItemsContainer}>
          <div className={styles.listItems}>
            {props.fetchingExtendedReplaceDomainNodes
              ? <ElementLoader />
              : <FilterReplacementsRemoveFiltersSelect
                replaceDomainNodes={props.replaceDomainNodes}
                removeDomainNodeOptions={props.removeDomainNodeOptions}
                valueItems={valueItems}
                onChange={onSelectChange}
                optionsIds={getSelectedDefaultOptionIds(props.replaceDomainNodes)}
                onLoadRemoveNodesFields={props.onLoadRemoveNodesFields}
                translation={props.translation}
                locale={props.locale} />}
          </div>
        </div>
      </div>
    </div>
  </>;
};
